<script>
export default {
    name: "IconBraces"
}
</script>

<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.4" clip-path="url(#clip0_1238_14244)">
            <path
                d="M3.516 7C4.20823 7 4.88492 7.20527 5.4605 7.58986C6.03607 7.97444 6.48467 8.52107 6.74958 9.16061C7.01449 9.80015 7.0838 10.5039 6.94875 11.1828C6.8137 11.8617 6.48036 12.4854 5.99087 12.9749C5.50139 13.4644 4.87775 13.7977 4.19882 13.9327C3.51988 14.0678 2.81615 13.9985 2.17661 13.7336C1.53707 13.4687 0.990441 13.0201 0.605856 12.4445C0.221271 11.8689 0.016 11.1922 0.016 10.5L0 10C0 8.14348 0.737498 6.36301 2.05025 5.05025C3.36301 3.7375 5.14348 3 7 3V5C6.3431 4.99823 5.69237 5.12671 5.08543 5.378C4.4785 5.62929 3.9274 5.9984 3.464 6.464C3.2839 6.64377 3.11775 6.83699 2.967 7.042C3.146 7.014 3.329 6.999 3.515 6.999L3.516 7ZM12.516 7C13.2082 7 13.8849 7.20527 14.4605 7.58986C15.0361 7.97444 15.4847 8.52107 15.7496 9.16061C16.0145 9.80015 16.0838 10.5039 15.9487 11.1828C15.8137 11.8617 15.4804 12.4854 14.9909 12.9749C14.5014 13.4644 13.8777 13.7977 13.1988 13.9327C12.5199 14.0678 11.8161 13.9985 11.1766 13.7336C10.5371 13.4687 9.99044 13.0201 9.60586 12.4445C9.22127 11.8689 9.016 11.1922 9.016 10.5L9 10C9 8.14348 9.7375 6.36301 11.0503 5.05025C12.363 3.7375 14.1435 3 16 3V5C15.3431 4.99823 14.6924 5.12671 14.0854 5.378C13.4785 5.62929 12.9274 5.9984 12.464 6.464C12.2839 6.64377 12.1177 6.83699 11.967 7.042C12.146 7.014 12.329 7 12.516 7Z"
                fill="#4241B8"/>
        </g>
        <defs>
            <clipPath id="clip0_1238_14244">
                <rect width="16" height="16" fill="white"/>
            </clipPath>
        </defs>
    </svg>
</template>

<style scoped lang="scss">

</style>
